import { AuthActionTypes } from './auth.actions';
import { setLanguage } from '@services/utils/locale';
import { setRegion } from '@services/utils/region';
import { LanguageShort } from '@enums/languages';
import { RegionIdentifier } from '@enums/region-identifier';
import { setUnitSystem } from '@services/utils/unit-system';
import { UnitSystemIdentifier } from '@enums/unit-system';

export function clearState(reducer) {
  const theme = localStorage.getItem('theme');

  return (state, action) => {
    if (action.type === AuthActionTypes.LOGOUT_SUCCESS) {
      const userStorage = localStorage.getItem('userSettings');
      const storageSettings = JSON.parse(userStorage);

      const user = JSON.parse(localStorage.getItem('user')) ?? {};
      const isFleetAccount = !user?.serviceAccount && !user?.supportAccount;

      sessionStorage.removeItem('notification.wasAlreadyShown');
      localStorage.clear();
      state = undefined;
      if (isFleetAccount) {
        setLanguage(storageSettings.appLanguageId);
        setRegion(storageSettings.appRegionId);
        setUnitSystem(storageSettings.appUnitSystemId);
      } else {
        setLanguage(LanguageShort.ENGLISH);
        setRegion(RegionIdentifier.Usa);
        setUnitSystem(UnitSystemIdentifier.IMPERIAL);
      }

      if (storageSettings?.appThemeId) {
        localStorage.setItem('theme', storageSettings.appThemeId);
      } else if (theme === null) {
        localStorage.setItem('theme', 'black');
      } else {
        localStorage.setItem('theme', theme);
      }
    }
    return reducer(state, action);
  };
}
